"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueryListSection = void 0;
var SearchSuggestionClick = _interopRequireWildcard(require("@ori-events/search-suggestion-click"));
var _analyticsData = require("@ori/analytics-data");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _Query = require("../Query");
var _constants = require("./constants");
var _queryListSectionClasses = require("./queryListSectionClasses");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const QueryListSection = ({
  title,
  items,
  query,
  placement = _analyticsData.Placement.TopNavigationSearchSuggestions,
  itemType = _analyticsData.ContentType.PopularQuery,
  className,
  showIcon = true,
  withPaddingBottom = false
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const rootClassName = (0, _clsx.default)(_queryListSectionClasses.queryListSectionClasses.root, className);
  const onQueryClick = (0, _react.useCallback)((selectedQuery, position, url) => () => {
    window.dispatchEvent(new CustomEvent(SearchSuggestionClick.Name, {
      detail: {
        itemData: {
          target: url ?? '',
          localBannerTitle: selectedQuery,
          media: []
        },
        itemType,
        searchQuery: query,
        placement,
        position
      }
    }));
    if (url) {
      window.location.href = url;
    }
  }, [itemType, placement, query]);
  if (items.length === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Section, {
    withPaddingBottom: withPaddingBottom,
    "data-testid": getTestId(_constants.QUERY_LIST_SECTION),
    className: rootClassName,
    children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SectionLabel, {
      className: _queryListSectionClasses.queryListSectionClasses.sectionLabel,
      variant: "caption",
      children: title
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Queries, {
      className: _queryListSectionClasses.queryListSectionClasses.queries,
      children: items.map(({
        text,
        url
      }, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Query.Query, {
        className: _queryListSectionClasses.queryListSectionClasses.query,
        text: text,
        showIcon: showIcon,
        searchPhrase: query,
        onClick: onQueryClick(text, index, url)
      }, text))
    })]
  });
};
exports.QueryListSection = QueryListSection;
//# sourceMappingURL=QueryListSection.js.map